import { useState } from "react";

const Contact = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="contact" className="py-8 text-white border-t border-gray-700">
      {/* Header with toggle */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 cursor-pointer focus:outline-none"
      >
        <h2 className="text-2xl font-bold">Contact</h2>
        <span
          className={`text-xl font-bold transform transition-transform duration-300`}
          style={{
            display: "inline-block",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          ﹀
        </span>
      </button>

      {/* Collapsible content */}
      {isOpen && (
        <div className="mt-4 max-w-3xl space-y-2">
          <p>
              Email:{" "}
              <a
                href="mailto:team@brightripplestudios.com"
                className="underline hover:text-gray-300"
              >
                team@brightripplestudios.com
              </a>
          </p>
            <p>Phone: +91 7302595984, +91 9520431804</p>
        </div>
      )}
    </section>
  );
};

export default Contact;
